"use client";

import { lazy } from "react";

const QRCodeClient = lazy(() => import("./QRCodeClient"));

export default function QRCodeLazy(props) {
  return <QRCodeClient {...props} />;
}
